import FilterParameter from '~/utils/FilterParameter/FilterParameter';

export default class Query<F extends string | string[] = string | string[]> {
	filterParameters: FilterParameter<F>[];

	currency: string | null;

	constructor(filterParameters: FilterParameter<F>[], currency: string | null) {
		this.filterParameters = filterParameters;
		this.currency = currency;
	}

	get isValid(): boolean {
		return this.filterParameters.find((parameter) => parameter.value.length !== 0) !== undefined;
	}

	get key(): string {
		const filterKey = this.filterParameters.reduce(
			(result, parameter) => `${result},${parameter.name}=${parameter.value}`,
			''
		);
		return `${filterKey}-${String(this.currency)}`;
	}

	equals(other: any): boolean {
		return (
			other instanceof Query && this.currency === other.currency && this.filterParametersEquals(other.filterParameters)
		);
	}

	filterParametersEquals(filterParameters: FilterParameter<F>[]): boolean {
		if (this.filterParameters === filterParameters) {
			return true;
		}
		if (this.filterParameters.length !== filterParameters.length) {
			return false;
		}
		return this.filterParameters.find((parameter, index) => !parameter.equals(filterParameters[index])) === undefined;
	}

	filterParametersUpdated(filterParameters: FilterParameter<F>[]): Query<F> {
		return new Query(filterParameters, this.currency);
	}

	currencyUpdated(currency: string): Query {
		return new Query(this.filterParameters, currency);
	}
}
